import { type FC, useCallback, type MouseEventHandler } from 'react';
import { FormattedMessage, useIntl } from 'dibs-react-intl';
import dibsCss from 'dibs-css';
import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';
import { handleLocaleUrl } from 'dibs-intl/exports/urls';
import classnames from 'classnames';
import { Button } from 'dibs-elements/exports/Button.tsx';
import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';

export const PdpSharedBuyerIncentivesLink: FC = () => {
    const intl = useIntl();
    const { isMobile } = useServerVarsContext();

    const incentivesLinkClick: MouseEventHandler = useCallback(event => {
        trackEvent(
            {
                eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
                interaction_type: interactionTypeConstants.INTERACTION_TYPE_PURCHASE_PROTECTION,
                step_interaction_name: stepInteractionConstants.STEP_INTERACTION_LEARN_MORE_CLICK,
                trigger: 'main cta learn more click',
            },
            event
        );
    }, []);

    const message = (
        <FormattedMessage id="PdpSharedBuyerIncentivesLink.learnMore" defaultMessage="Learn More" />
    );

    return (
        <div
            className={classnames(dibsCss.flex, dibsCss.justifyCenter, {
                [dibsCss.mtMedium]: isMobile,
                [dibsCss.mtLarge]: !isMobile,
                [dibsCss.pbXsmall]: isMobile,
            })}
        >
            <Button
                href={handleLocaleUrl('/about/purchase-protection/', intl.locale)}
                target="_blank"
                type="secondary"
                size="medium"
                onClick={incentivesLinkClick}
                className={classnames(
                    dibsCss.sassyFontSubHeaderMediumNormal,
                    isMobile ? dibsCss.wFull : dibsCss.w300px
                )}
                fullWidth={!!isMobile}
            >
                {message}
            </Button>
        </div>
    );
};
